"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9650],{

/***/ 50379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Toggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(53089);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var dist_esm = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@tamagui/label/dist/esm/Label.mjs + 2 modules
var Label = __webpack_require__(65910);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-previous/dist/esm/index.mjs
var use_previous_dist_esm = __webpack_require__(82375);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/switch-headless/dist/esm/useSwitch.mjs







function getState(checked) {
  return checked ? "checked" : "unchecked";
}
const BubbleInput = props => {
  const {
      control,
      checked,
      bubbles = !0,
      ...inputProps
    } = props,
    ref = react.useRef(null),
    prevChecked = (0,use_previous_dist_esm/* usePrevious */.D)(checked);
  return react.useEffect(() => {
    const input = ref.current,
      inputProto = window.HTMLInputElement.prototype,
      setChecked = Object.getOwnPropertyDescriptor(inputProto, "checked").set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked), input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]),
  // @ts-ignore
  /* @__PURE__ */
  (0,jsx_runtime.jsx)("input", {
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: checked,
    ...inputProps,
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  });
};
function useSwitch(props, [checked, setChecked], ref) {
  const {
      disabled,
      name,
      value,
      required
    } = props,
    hasConsumerStoppedPropagationRef = react.useRef(!1),
    [button, setButton] = react.useState(null),
    composedRefs = (0,compose_refs/* useComposedRefs */.ex)(ref, setButton),
    isFormControl = esm/* isWeb */.$L ? button ? !!button.closest("form") : !0 : !1,
    labelId = (0,Label/* useLabelContext */.t0)(button),
    ariaLabelledBy = props["aria-labelledby"] || props.labeledBy || labelId;
  return {
    switchProps: {
      role: "switch",
      "aria-checked": checked,
      ...(esm/* isWeb */.$L ? {
        tabIndex: disabled ? void 0 : 0,
        "data-state": getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled
      } : {}),
      ...props,
      "aria-labelledby": ariaLabelledBy,
      onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, event => {
        setChecked(prevChecked => !prevChecked), esm/* isWeb */.$L && isFormControl && (hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(), hasConsumerStoppedPropagationRef.current || event.stopPropagation());
      })
    },
    switchRef: composedRefs,
    /**
     * insert as a sibling of your switch (should not be inside the switch)
     */
    bubbleInput: esm/* isWeb */.$L && isFormControl ? /* @__PURE__ */(0,jsx_runtime.jsx)(BubbleInput, {
      control: button,
      bubbles: !hasConsumerStoppedPropagationRef.current,
      name,
      value,
      checked,
      required,
      disabled,
      style: {
        transform: "translateX(-100%)"
      }
    }) : null
  };
}

//# sourceMappingURL=useSwitch.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toggle/Toggle.js










var toggleTokens = Components/* tokens.toggle */.T.toggle, Frame = (0,cjs.styled)(cjs.View, {
    // Use <button> tag for a11y so space/enter keys toggle the switch.
    // See: https://www.w3.org/WAI/ARIA/apg/patterns/switch/
    tag: "button",
    // @ts-expect-error - need type="button" to prevent form submission on web
    type: "button",
    padding: 0,
    flexDirection: "row",
    alignSelf: "flex-start",
    backgroundColor: toggleTokens.color.background.element.toggle.default,
    cursor: "pointer",
    borderStyle: "solid",
    borderWidth: toggleTokens.borderWidth.element.state.default,
    borderColor: toggleTokens.color.border.element.toggle.state.default,
    outlineStyle: "none",
    borderRadius: toggleTokens.cornerRadius.element.toggle.large,
    animation: "accelerateDecelerateFastest",
    animateOnly: cjs.isWeb ? [
        "background-color",
        "border-color"
    ] : [
        "backgroundColor",
        "borderColor"
    ],
    focusVisibleStyle: {
        borderColor: toggleTokens.color.border.element.toggle.state.focused
    },
    variants: {
        frameSize: function(size) {
            return {
                height: toggleTokens.size.element.onOff[size]
            };
        },
        hasError: {
            true: {
                borderColor: toggleTokens.color.border.element.toggle.state.error,
                "aria-invalid": !0
            }
        },
        disabled: {
            true: {
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        },
        embedded: {
            true: {
                maxWidth: 80
            },
            false: {
                minWidth: 320
            }
        }
    }
}), Content = (0,cjs.styled)(cjs.View, {
    alignItems: "center",
    justifyContent: "center",
    variants: {
        frameSize: function(size) {
            return {
                width: 140,
                height: toggleTokens.size.element.onOff[size],
                borderRadius: toggleTokens.cornerRadius.element.toggle.large
            };
        },
        embedded: {
            true: {
                maxWidth: 40
            },
            false: {
                minWidth: 140
            }
        }
    }
}), Thumb = (0,cjs.styled)(cjs.View, {
    backgroundColor: toggleTokens.color.background.element.toggle.on,
    variants: {
        frameSize: function(size) {
            return {
                height: toggleTokens.size.element.onOff[size],
                borderRadius: toggleTokens.cornerRadius.element.toggle.large
            };
        },
        embedded: {
            true: {
                maxWidth: 80
            },
            false: {
                minWidth: 140
            }
        },
        hasError: {
            true: {
                backgroundColor: toggleTokens.color.background.element.toggle.state.errorOn
            }
        },
        disabled: {
            true: {
                backgroundColor: toggleTokens.color.background.element.toggle.state.inactiveOn
            }
        }
    }
}), Toggle = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var leftIcon = _param.leftIcon, rightIcon = _param.rightIcon, size = _param.size, hasError = _param.hasError, leftLabel = _param.leftLabel, rightLabel = _param.rightLabel, isEmbeddedInTextInput = _param.isEmbeddedInTextInput, props = (0,_object_without_properties/* default */.Z)(_param, [
        "leftIcon",
        "rightIcon",
        "size",
        "hasError",
        "leftLabel",
        "rightLabel",
        "isEmbeddedInTextInput"
    ]);
    var _$ref = (0,react.useState)(props.defaultChecked || !1), checked = _$ref[0], setChecked = _$ref[1], _$ref1 = useSwitch(props, [
        checked,
        setChecked
    ], ref), switchProps = _$ref1.switchProps, switchRef = _$ref1.switchRef, bubbleInput = _$ref1.bubbleInput, onCheckedChange = switchProps.onCheckedChange, restSwitchProps = (0,_object_without_properties/* default */.Z)(switchProps, [
        "onCheckedChange"
    ]);
    (0,react.useEffect)(function() {
        onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange(checked);
    }, [
        checked
    ]);
    var animation = (0,react.useRef)(new Animated/* default.Value */.Z.Value(checked ? 1 : 0));
    (0,react.useEffect)(function() {
        Animated/* default.timing */.Z.timing(animation.current, {
            toValue: checked ? 1 : 0,
            duration: 80,
            useNativeDriver: !0
        }).start();
    }, [
        checked
    ]);
    var getIconColor = (0,react.useCallback)(function(isSelected) {
        return props.disabled ? isSelected ? toggleTokens.color.content.element.toggle.state.inactiveOn : toggleTokens.color.content.element.toggle.state.inactiveOff : hasError && !isSelected ? toggleTokens.color.content.element.toggle.state.error : isSelected ? toggleTokens.color.content.element.toggle.on : toggleTokens.color.content.element.toggle.off;
    }, [
        props.disabled,
        hasError
    ]), _$ref2 = (0,react.useState)(0), leftWidth = _$ref2[0], setLeftWidth = _$ref2[1], _$ref3 = (0,react.useState)(0), rightWidth = _$ref3[0], setRightWidth = _$ref3[1];
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Frame, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: switchRef
            }, restSwitchProps), {
                disabled: !!switchProps.disabled,
                frameSize: size,
                hasError: hasError,
                embedded: isEmbeddedInTextInput,
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                        style: [
                            {
                                position: "absolute",
                                width: checked ? rightWidth : leftWidth,
                                transform: [
                                    {
                                        translateX: animation.current.interpolate({
                                            inputRange: [
                                                0,
                                                1
                                            ],
                                            outputRange: [
                                                0,
                                                leftWidth
                                            ]
                                        })
                                    }
                                ]
                            }
                        ],
                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Thumb, {
                            frameSize: size,
                            hasError: hasError,
                            disabled: props.disabled,
                            embedded: isEmbeddedInTextInput
                        })
                    }),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Content, {
                        frameSize: size,
                        embedded: isEmbeddedInTextInput,
                        onLayout: function(e) {
                            return setLeftWidth(e.nativeEvent.layout.width);
                        },
                        paddingHorizontal: leftLabel ? "$9x" : "$4x",
                        children: rightLabel ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            tag: "span",
                            typography: size === "small" ? toggleTokens.typography.element.smallSize : toggleTokens.typography.element.mediumSize,
                            color: getIconColor(!checked),
                            children: leftLabel
                        }) : (leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.Component) && /* @__PURE__ */ (0,jsx_runtime.jsx)(leftIcon.Component, {
                            "aria-label": leftIcon.label,
                            color: getIconColor(!checked)
                        })
                    }),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Content, {
                        frameSize: size,
                        embedded: isEmbeddedInTextInput,
                        onLayout: function(e) {
                            return setRightWidth(e.nativeEvent.layout.width);
                        },
                        paddingHorizontal: rightLabel ? "$9x" : "$4x",
                        children: rightLabel ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            tag: "span",
                            typography: size === "small" ? toggleTokens.typography.element.smallSize : toggleTokens.typography.element.mediumSize,
                            color: getIconColor(checked),
                            children: rightLabel
                        }) : (rightIcon === null || rightIcon === void 0 ? void 0 : rightIcon.Component) && /* @__PURE__ */ (0,jsx_runtime.jsx)(rightIcon.Component, {
                            "aria-label": rightIcon.label,
                            color: getIconColor(checked)
                        })
                    })
                ]
            })),
            bubbleInput
        ]
    });
});



/***/ }),

/***/ 27825:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRailsEnv = void 0;
exports.isRailsEnv = isRailsEnv;
exports.assertRailEnvOrThrow = assertRailEnvOrThrow;
var envs = ['production', 'staging', 'qa', 'development', 'test'];
function isRailsEnv(env) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return envs.includes(env);
}
function assertRailEnvOrThrow(env) {
    if (isRailsEnv(env)) {
        return env;
    }
    throw new Error("".concat(env, " is not a valid RailsEnv"));
}
var getRailsEnv = function () {
    var _a, _b, _c, _d;
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 'development';
    }
    var hostname = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    if (hostname === undefined) {
        return 'development';
    }
    var port = (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.port;
    var locationHasPort = port && port !== '';
    var onLocalhost = hostname === 'localhost';
    var onNgrok = hostname.includes('.ngrok.io');
    var onXipIO = hostname.includes('.xip.io');
    var inAndroidEmulator = hostname.includes('10.0.2.2');
    var inDevelopment = (onLocalhost && locationHasPort) || onNgrok || onXipIO || inAndroidEmulator;
    if (inDevelopment) {
        return 'development';
    }
    // In Rails CI, tests my be on a random port
    var inRailsCI = hostname === '127.0.0.1';
    // on localhost without a port corresponds to test environment
    if (inRailsCI || onLocalhost) {
        return 'test';
    }
    var onStagingManagedDomain = hostname.includes('-staging.managed.services.opendoor.com') ||
        hostname.includes('-staging.ops.opendoor.com') ||
        hostname.includes('-staging.opendoor.com');
    var onSimplersell = hostname.includes('.simplersell.com');
    var onODMortgage = hostname.includes('.odmortgage.com');
    var inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
    var inProduction = hostname.includes('.opendoor.com') && !hostname.includes('-staging');
    var inProdOrStaging = inStaging || inProduction;
    var onQADomain = hostname.includes('-qa-');
    var hasQACookie = ((_c = document === null || document === void 0 ? void 0 : document.cookie) === null || _c === void 0 ? void 0 : _c.includes('qa=')) && ((_d = document === null || document === void 0 ? void 0 : document.cookie) === null || _d === void 0 ? void 0 : _d.includes('qa_env='));
    // most QA usage will be on a staging domain (.e.g `demo.simplersell.com`) with appropriate
    // cookies set
    var inQA = onQADomain || (inProdOrStaging && hasQACookie);
    if (inQA) {
        return 'qa';
    }
    else if (inStaging) {
        return 'staging';
    }
    else if (inProduction) {
        return 'production';
    }
    // default case
    return 'development';
};
exports.getRailsEnv = getRailsEnv;


/***/ }),

/***/ 59433:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ AccordionList; }
/* harmony export */ });
/* unused harmony export SeeAllLink */
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8013);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93298);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4796);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47208);
/* harmony import */ var _core_Icon_Icon_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49154);
/* harmony import */ var _core_List_AccordionListItem_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55662);
/* harmony import */ var _hooks_useMedia_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61151);
function cov_253a01gitz() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Accordion/AccordionList.tsx";
  var hash = "6b576b139f6b90ed3f657b2faffd33a6a864409d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Accordion/AccordionList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 70,
          column: 60
        },
        end: {
          line: 108,
          column: 1
        }
      },
      "1": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 107,
          column: 4
        }
      },
      "2": {
        start: {
          line: 95,
          column: 10
        },
        end: {
          line: 103,
          column: 16
        }
      },
      "3": {
        start: {
          line: 114,
          column: 53
        },
        end: {
          line: 131,
          column: 1
        }
      },
      "4": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 34
        }
      },
      "5": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 130,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 70,
            column: 60
          },
          end: {
            line: 70,
            column: 61
          }
        },
        loc: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 108,
            column: 1
          }
        },
        line: 77
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 94,
            column: 31
          }
        },
        loc: {
          start: {
            line: 95,
            column: 10
          },
          end: {
            line: 103,
            column: 16
          }
        },
        line: 95
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 114,
            column: 53
          },
          end: {
            line: 114,
            column: 54
          }
        },
        loc: {
          start: {
            line: 114,
            column: 82
          },
          end: {
            line: 131,
            column: 1
          }
        },
        line: 114
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 75,
            column: 13
          },
          end: {
            line: 75,
            column: 18
          }
        }],
        line: 75
      },
      "1": {
        loc: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 22
          }
        }],
        line: 76
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 7
          },
          end: {
            line: 89,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 13
          }
        }, {
          start: {
            line: 80,
            column: 17
          },
          end: {
            line: 80,
            column: 21
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 88,
            column: 15
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 82,
            column: 11
          },
          end: {
            line: 86,
            column: 18
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 85,
            column: 19
          }
        }, {
          start: {
            line: 86,
            column: 14
          },
          end: {
            line: 86,
            column: 18
          }
        }],
        line: 82
      },
      "4": {
        loc: {
          start: {
            line: 87,
            column: 11
          },
          end: {
            line: 87,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 18
          },
          end: {
            line: 87,
            column: 74
          }
        }, {
          start: {
            line: 87,
            column: 77
          },
          end: {
            line: 87,
            column: 81
          }
        }],
        line: 87
      },
      "5": {
        loc: {
          start: {
            line: 91,
            column: 22
          },
          end: {
            line: 91,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 46
          },
          end: {
            line: 91,
            column: 52
          }
        }, {
          start: {
            line: 91,
            column: 55
          },
          end: {
            line: 91,
            column: 68
          }
        }],
        line: 91
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 25
          },
          end: {
            line: 92,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 49
          },
          end: {
            line: 92,
            column: 60
          }
        }, {
          start: {
            line: 92,
            column: 63
          },
          end: {
            line: 92,
            column: 75
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 25
          },
          end: {
            line: 100,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 56
          },
          end: {
            line: 100,
            column: 70
          }
        }, {
          start: {
            line: 100,
            column: 73
          },
          end: {
            line: 100,
            column: 94
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 127,
            column: 57
          },
          end: {
            line: 127,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 68
          },
          end: {
            line: 127,
            column: 70
          }
        }, {
          start: {
            line: 127,
            column: 73
          },
          end: {
            line: 127,
            column: 75
          }
        }],
        line: 127
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6b576b139f6b90ed3f657b2faffd33a6a864409d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_253a01gitz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_253a01gitz();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







/**
 * Component that stacks accordions ontop of each other Font for heading &
 * see-all link will update based on device used to view accordion Developer can
 * optionally pass a title to render a title on accordionList Developer can
 * optionally pass a link to render a "See all" link that directs user to
 * another page for more information If using AccordionList in a bundle
 * sensitive application (example: Cosmos) that uses Selective Spritesheet you
 * must import - ChevronDown16 to get the chevron to appear
 *
 * An accordion is a vertically stacked list of headers that reveal or hide
 * associated sections of content.
 *
 * AccordionList size variations
 * ------------------------------------------------------------------------------------------------------------
 *
 * "standard"
 *
 * "compact"
 *
 *
 * ## Analytics
 *
 * `AccordionList`is set up to track impressions and click events:
 *
 * * ClickEvents - pass the analyticsName List to track the accordion click
 * event
 *
 * * ImpressionEvents - pass `trackImpression={true}` to List to track the
 * impression event
 *
 * Note: We do not track impressions directly on AccordionListItem but track
 * impression events on List
 * ([AccordionListWithTracking](https://github.com/opendoor-labs/code/blob/master/js/packages/bricks/src/core/List/List.tsx#LL94C18-L94C18)).
 * This way we track the view event for the accordion as a whole instead of for
 * each accordion panel.
 *
 * Events will be sent to journey service and will end up in the corresponding
 * tables (e.g. journey\_service\_production.platform\_accordion\_click\_event
 * for accordion click events)
 *
 * * For more information on tracking please refer here:
 * [https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_253a01gitz().s[0]++;
var AccordionList = function AccordionList(_ref) {
  var analyticsName = _ref.analyticsName,
    listOfAccordions = _ref.listOfAccordions,
    title = _ref.title,
    link = _ref.link,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? (cov_253a01gitz().b[0][0]++, false) : _ref$wrapText,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? (cov_253a01gitz().b[1][0]++, 'standard') : _ref$variant;
  cov_253a01gitz().f[0]++;
  cov_253a01gitz().s[1]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    width: "100%"
  }, ((cov_253a01gitz().b[2][0]++, title) || (cov_253a01gitz().b[2][1]++, link)) && (cov_253a01gitz().b[2][2]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    justifyContent: "space-between",
    pb: 5
  }, title ? (cov_253a01gitz().b[3][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    fontSize: "s2",
    fontWeight: "semibold",
    color: "neutrals90"
  }, title)) : (cov_253a01gitz().b[3][1]++, null), link ? (cov_253a01gitz().b[4][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(SeeAllLink, {
    link: link,
    analyticsName: analyticsName
  })) : (cov_253a01gitz().b[4][1]++, null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    borderRadius: variant === 'compact' ? (cov_253a01gitz().b[5][0]++, 'none') : (cov_253a01gitz().b[5][1]++, 'semiRounded'),
    backgroundColor: variant === 'compact' ? (cov_253a01gitz().b[6][0]++, 'neutrals0') : (cov_253a01gitz().b[6][1]++, 'neutrals10')
  }, listOfAccordions.map(function (item, index) {
    cov_253a01gitz().f[1]++;
    cov_253a01gitz().s[2]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      key: "item-".concat(index)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_List_AccordionListItem_mjs__WEBPACK_IMPORTED_MODULE_7__/* .AccordionListItem */ .rB, _extends({
      analyticsName: analyticsName,
      wrapText: wrapText
      // if item.noPadding is specified, use that, if not, set if compact
      ,
      noPadding: item.noPadding !== undefined ? (cov_253a01gitz().b[7][0]++, item.noPadding) : (cov_253a01gitz().b[7][1]++, variant === 'compact')
    }, item)));
  })));
};

/**
 * Component that handles opening up a new page for more information
 * Will only appear if a link is passed through to AccordionList
 */
cov_253a01gitz().s[3]++;
var SeeAllLink = function SeeAllLink(_ref2) {
  var link = _ref2.link,
    analyticsName = _ref2.analyticsName;
  cov_253a01gitz().f[2]++;
  var _ref3 = (cov_253a01gitz().s[4]++, (0,_hooks_useMedia_mjs__WEBPACK_IMPORTED_MODULE_8__/* .useDevice */ .F)()),
    isMobile = _ref3.isMobile;
  cov_253a01gitz().s[5]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    href: link,
    target: "_blank",
    fontWeight: "semibold",
    fontSize: ['s0', 's0', 's2', 's2'],
    analyticsName: analyticsName,
    "aria-label": 'Select to get more information'
  }, "See all", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_Icon_Icon_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    name: "chevron-right",
    color: "brand50",
    size: isMobile ? (cov_253a01gitz().b[8][0]++, 12) : (cov_253a01gitz().b[8][1]++, 16)
  })));
};

/***/ }),

/***/ 77373:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconX; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M18 6l-12 12", "key": "svg-0" }], ["path", { "d": "M6 6l12 12", "key": "svg-1" }]];
const IconX = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "x", "X", __iconNode);


//# sourceMappingURL=IconX.mjs.map


/***/ })

}]);